import React, { useState, useEffect } from 'react';
import { getAutomationsBySymbol } from '../../../services/AutomationsService';
import { processError } from '../../../services/ServiceUtils';

const ACTION_LABELS = {
    ORDER:            a => `${a.orderTemplate?.side === 'BUY' ? '📈' : '📉'} Ordem${a.orderTemplate ? ` — ${a.orderTemplate.name}` : ''}`,
    ALERT_EMAIL:      () => '📧 Alerta por email',
    ALERT_SMS:        () => '📱 Alerta por SMS',
    ALERT_TELEGRAM:   () => '✈️ Alerta Telegram',
    AI_ANALYSIS:      () => '🤖 Análise IA',
    AI_MARKET_SCAN:   () => '🔍 Scanner de mercado',
    AI_ALERT:         () => '🤖 Alerta IA',
    GRID:             () => '📊 Grid',
    WITHDRAW:         () => '💸 Saque',
    TRAILING:         () => '🔄 Trailing stop',
    ENABLE_AUTOMATION:  () => '▶ Ativar automação',
    DISABLE_AUTOMATION: () => '⏹ Parar automação',
};

/**
 * props:
 * - symbol
 * - id
 * - automationId
 * - onChange
 */
function SelectAutomation(props) {
    const [automations, setAutomations] = useState([]);

    useEffect(() => {
        if (!props.symbol) return setAutomations([]);
        getAutomationsBySymbol(props.symbol)
            .then(result => setAutomations(result))
            .catch(err => setAutomations([processError(err)]));
    }, [props.symbol]);

    function onAutomationChange(event) {
        if (props.onChange) props.onChange(event);
    }

    const selected = automations.find(a => String(a.id) === String(props.automationId));
    const actions = selected?.actions || [];

    return (
        <>
            <select className='form-select' id={props.id ? props.id : 'automationId'} value={props.automationId} onChange={onAutomationChange}>
                <option value='0'>Selecionar automação...</option>
                {automations.map(a => (<option key={a.id} value={a.id}>{a.name}</option>))}
            </select>
            {actions.length > 0 && (
                <div className='mt-1 ps-1' style={{ fontSize: 12, color: '#6c757d' }}>
                    {actions.map((a, i) => (
                        <div key={i}>{(ACTION_LABELS[a.type] || (() => a.type))(a)}</div>
                    ))}
                </div>
            )}
        </>
    );
}

export default SelectAutomation;